import React from "react";
import { Redirect } from "react-router-dom";

import consts from "../main/consts";
import { useRemoteConfig } from "../state/remoteConfig/RemoteConfigContext";

const MenuEnabledGuard = ({
  menuId,
  redirectTo = `${consts.CONTEXT}/all-orders`,
  children,
}) => {
  const { isMenuEnabled, loading } = useRemoteConfig();

  if (loading) return null;

  if (isMenuEnabled && !isMenuEnabled(menuId)) {
    return <Redirect to={redirectTo} />;
  }

  return children;
};

export default MenuEnabledGuard;
